export const pageLandingRichTextTransformer = (props) => ({
    title: props?.fieldTitleLong ?? '',
    text: props?.fieldBody?.processed ?? '',
})
